import { baseApi } from '../baseApi';
import { Plan } from './planApi';

export interface Order {
  id: string;
  userId: string;
  planId: string;
  amount: number;
  paymentStatus: 'Pending' | 'Success' | 'Failed';
  paymentMethod?: string;
  transactionId?: string;
  startDate?: string;
  endDate?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  user?: {
    id: string;
    name: string;
    email: string;
    mobile: string;
  };
  plan?: Plan;
}

export const orderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrders: builder.query<{ success: boolean; data: Order[] }, any>({
      query: (params) => ({
        url: '/api/orders',
        params: params || undefined,
      }),
      providesTags: ['Order' as any],
    }),
    getOrderById: builder.query<{ success: boolean; data: Order }, string>({
      query: (id) => `/api/orders/${id}`,
      providesTags: ['Order' as any],
    }),
    createOrder: builder.mutation<{ success: boolean; data: Order }, Partial<Order>>({
      query: (body) => ({
        url: '/api/orders',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Order' as any],
    }),
    updateOrder: builder.mutation<{ success: boolean; data: Order }, { id: string; body: Partial<Order> }>({
      query: ({ id, body }) => ({
        url: `/api/orders/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Order' as any],
    }),
    deleteOrder: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/orders/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Order' as any],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetOrdersQuery,
  useGetOrderByIdQuery,
  useCreateOrderMutation,
  useUpdateOrderMutation,
  useDeleteOrderMutation,
} = orderApi;
